import React from 'react';
import useSearchParams from '../../../useSearchParams';
import CheckboxGroup from './CheckboxGroup';
import Header from '../Header';
import Footer from './Footer';

const options = [
  {
    value: '0',
    text: 'Low',
  },
  {
    value: '1',
    text: 'Middle',
  },
  {
    value: '2',
    text: 'High',
  },
];

const PriorityFilter = () => {
  const {query, setQuery} = useSearchParams();

  return (
    <>
      <Header title="優先度" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-2">
          <CheckboxGroup
            options={options.map((priority) => ({
              text: priority.text,
              value: priority.value,
              keyword: priority.text,
            }))}
            values={query.priorities || []}
            onChange={(priorities) => setQuery({...query, priorities})}
          />
        </div>
      </div>
      <Footer onClear={() => setQuery({...query, priorities: []})} />
    </>
  );
};

export default PriorityFilter;
